'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const Symbol_module = require('../../../../Symbol.module-CBwbHbxh.js');

const SymbolSize20 = () => {
  return jsxRuntime.jsx("svg", { className: Symbol_module.styles.root, width: "20", height: "20", "data-testid": "ZapierLogoSymbolSmall", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: jsxRuntime.jsx("rect", { width: "20", height: "20", rx: "3", fill: "#FF4F00" }) });
};

exports.SymbolSize20 = SymbolSize20;
//# sourceMappingURL=SymbolSize20.cjs.js.map
